import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";


class SubItem3 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item3">
                <Row style={{backgroundColor: "fff", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={4}>
                        
                    </Col>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Perfil del egresado</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El Diseñador Gráfico formado en nuestra institución es un profesional integral, competitivo, capacitado para crear, analizar, evaluar, investigar y desarrollar proyectos de comunicación visual con la más alta tecnología, así como enfrentar planteamientos estratégicos y de gestión en los ámbitos comercial, corporativo, institucional y de la sociedad en general, con una actitud a favor de la sustentabilidad y la ética.
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem3;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoGrafico/SubItem3.jsx